import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useStrategyMapService } from '../../services/strategyMap';
import { SMapAction } from '../../redux/slices/strategyMap';

export const useSmapFetch = (
  initialPerPage: number = 10
) => {
  const {  fetchLeveldSmap, resetStrategyMaps } = useStrategyMapService();
  const dispatch = useDispatch();

  const {
      smaps: data,
      loading,
      loadingMore,
      error,
      total,
      page,
      totalPages,
      searchTerm
  } = useSelector((state: any) => state.levelMapList);

  const loadStrategyMaps = useCallback(async (
    pageNumber: number,
    search: string = searchTerm,
    searchType: string = 'smap',
    sortMap?: string | null,
    source?: string | null
  ) => {
    // if(pageNumber == 1) resetStrategyMaps()
    try {
      await fetchLeveldSmap(
        pageNumber,
        initialPerPage,
        search,
        searchType,
        sortMap || null,
        source || null
      );
    } catch (err) {
      console.error('Error loading level smaps:', err);
    }
  }, [initialPerPage, fetchLeveldSmap, searchTerm]);



  const refreshStrategyMaps = useCallback(async (
    search: string = searchTerm,
    searchType: string = 'smap',
    sortMap?: string | null,
    source?: string | null
  ) => {
    resetStrategyMaps();
    return loadStrategyMaps(1, search, searchType, sortMap, source);
  }, [ searchTerm, loadStrategyMaps, resetStrategyMaps]);

  return {
    loading,
    loadingMore,
    data,
    total,
    page,
    totalPages,
    error,
    loadStrategyMaps,
    resetStrategyMaps,
    refreshStrategyMaps
  };
};
